import "./approval-route.scss";

import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {ApprovalRequests} from "./approval-requests";

import {OrdersLayout} from "../common/orders-layout";

export const AccountApprovalRoute = () => cs(
    ({}, next) => OrdersLayout({activeTab: "approval", next}),
    ({}) => (
        <div className="approval-route-n5t">
            <ApprovalRequests/>
        </div>
    ),
);

